import { createApi } from '@reduxjs/toolkit/query/react'
import getQuery from '../../helpers/api/get-query'
import Overtime from '../../types/api/overtime'
import Strapi, {
    EndpointQueryParameters,
    StrapiCreate,
    StrapiSingle,
} from '../../types/strapi/strapi'
import getCustomFetchBase from '../custom-fetch-base'

export const overtimesApi = createApi({
    reducerPath: 'overtimesApi',
    baseQuery: getCustomFetchBase({ baseUrl: import.meta.env.VITE_API_URL }),
    tagTypes: ['Overtimes'],
    endpoints: builder => ({
        getOvertimes: builder.query<Strapi<Overtime>, EndpointQueryParameters | void>({
            query: getQuery('/overtimes'),
            providesTags: ['Overtimes'],
        }),
        createOvertime: builder.mutation<StrapiSingle<Overtime>, StrapiCreate<Overtime>>({
            query: body => ({
                url: '/overtimes',
                method: 'POST',
                body,
            }),
            invalidatesTags: ['Overtimes'],
        }),
        deleteOvertime: builder.mutation<void, string>({
            query: docId => ({
                url: `/overtimes/${docId}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['Overtimes'],
        }),
    }),
})

export const { useGetOvertimesQuery, useCreateOvertimeMutation, useDeleteOvertimeMutation } =
    overtimesApi
